import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getAccessToken, getStoredUserRole } from "@/shared/infrastructure/auth/token-storage";
import { DoctorShell } from "@/app/layout/DoctorShell";
import { UserRole } from "@/modules/auth/domain/entities";

/**
 * Segmento de URL real ("/doctor"), não uma rota pathless como "_authenticated" —
 * um layout pathless aqui colidiria com o índice "/" do paciente.
 */
export const Route = createFileRoute("/doctor")({
  beforeLoad: () => {
    const token = getAccessToken();
    const role = getStoredUserRole();

    if (!token || role !== UserRole.Doctor) {
      throw redirect({ to: "/doctor-login" });
    }
  },
  component: () => (
    <DoctorShell>
      <Outlet />
    </DoctorShell>
  ),
});
